import { render, staticRenderFns } from "./PosPaymentReport.vue?vue&type=template&id=050a3ab6"
import script from "./PosPaymentReport.vue?vue&type=script&lang=js"
export * from "./PosPaymentReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports